import TextInput from "components/inputs/text-input";
import ModalTemplate from "components/modal/modal-template";
import React, { useState } from "react";
import styled from "styled-components";
import { isValidUrl } from "utils/isValidUrl";

interface IProps {
  close: () => void;
  platform: string;
  link: string;
  setLink: (link: string) => void;
  save: () => void;
  artist?: boolean;
}
const AddLinkModal = ({
  platform,
  close,
  link,
  setLink,
  save,
  artist
}: IProps) => {
  const [value, setValue] = useState(link);
  return (
    <ModalTemplate
      close={close}
      header={`Add Your ${platform}`}
      confirmText="Save"
      confirm={() => {
        setLink(value);
        save();
      }}
      twoButtons
      disableConfirm={!isValidUrl(value)}
      cancelText="Cancel"
    >
      <InputContainer>
        <TextInput
          label={`${platform} ${artist ? "Artist" : ""} URL`}
          placeholder={`Enter ${platform} Artist link`}
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
          }}
        />
      </InputContainer>
    </ModalTemplate>
  );
};

export default AddLinkModal;

const InputContainer = styled.div`
  padding: 1rem 0;
  width: 100%;
  min-width: 40rem;
`;
